var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.137 11.552c-1.93 1.358-3.186 3.56-3.186 6.045 0 .986.548 1.787 1.438 2.402C4.994 19.73 3 18.929 3 17.597c0-3.265 2.68-5.926 6.03-6.042l.107-.003ZM14 11.5c3.314 0 6 2.691 6 6.01 0 3.32-12 3.32-12 0 0-3.319 2.686-6.01 6-6.01ZM9.26 3c.252 0 .5.025.738.071a4.885 4.885 0 0 0-1.476 3.492 4.88 4.88 0 0 0 1.477 3.491 3.845 3.845 0 0 1-.74.072c-2.037 0-3.688-1.596-3.688-3.563C5.571 4.595 7.222 3 9.259 3ZM14 3a3.539 3.539 0 0 1 3.536 3.542A3.539 3.539 0 0 1 14 10.083a3.539 3.539 0 0 1-3.536-3.541A3.539 3.539 0 0 1 14 3Z",
  fill: "currentColor"
}))));

export default SvgUsers;